export default Object.freeze({
  Permanent: 'P',
  Contact: 'C',
  Semester: 'S'
})
